module.exports = __webpack_public_path__ + "assets/img/66b15279c48e113f0e4b99b2991e4b0c.png";